import React from 'react'
import {
  montarArvoreNumerada, rawToHtml, applyPlaceholders, highlightPlaceholders,
} from './minutaRender'

/**
 * Preview do modelo montado, com numeração derivada e placeholders.
 * props:
 *  - itens: minutaModItem[]
 *  - blocoById, secById, clausById: dicionários id->registro do catálogo
 *  - contrato: registro de contrato (opcional). Se ausente, placeholders são destacados.
 */
const ModeloPreview = ({
  itens, blocoById, secById, clausById, contrato = null,
}) => {
  const arvore = montarArvoreNumerada(itens)

  const renderCorpo = (body) => {
    let html = rawToHtml(body)
    html = contrato ? applyPlaceholders(html, contrato) : highlightPlaceholders(html)
    // eslint-disable-next-line react/no-danger
    return <span dangerouslySetInnerHTML={{ __html: html }} />
  }

  const renderItem = (node) => {
    const { item, numero, filhos } = node
    if (item.minutaModItem_tipo === 'bloco') {
      const bloco = blocoById[item.minutaBloco_id]
      if (!bloco) return null
      return (
        <div className="minuta-prev-bloco" key={item.minutaModItem_id}>
          {renderCorpo(bloco.minutaBloco_body)}
        </div>
      )
    }
    if (item.minutaModItem_tipo === 'secao') {
      const sec = secById[item.minutaSec_id]
      return (
        <div key={item.minutaModItem_id}>
          <div className="minuta-prev-sec">
            <span className="minuta-prev-num">{numero}</span>
            {sec ? sec.minutaSec_nome : '(seção removida)'}
          </div>
          {filhos.map((f) => {
            const cl = clausById[f.item.minutaClaus_id]
            return (
              <div className="minuta-prev-claus" key={f.item.minutaModItem_id} style={{ marginLeft: 18 }}>
                <span className="minuta-prev-num">{f.numero}</span>
                {cl ? renderCorpo(cl.minutaClaus_body) : '(cláusula removida)'}
              </div>
            )
          })}
        </div>
      )
    }
    // cláusula avulsa (raiz)
    const cl = clausById[item.minutaClaus_id]
    return (
      <div className="minuta-prev-claus" key={item.minutaModItem_id}>
        <span className="minuta-prev-num">{numero}</span>
        {cl ? renderCorpo(cl.minutaClaus_body) : '(cláusula removida)'}
      </div>
    )
  }

  if (!itens || itens.length === 0) {
    return <div className="text-muted text-center py-4">Modelo vazio — arraste itens para montar.</div>
  }

  return <div className="minuta-preview">{arvore.map(renderItem)}</div>
}

export default ModeloPreview
